import { Controller } from '@hotwired/stimulus'
import { Chart } from 'chart.js/auto'
import ChartDataLabels from 'chartjs-plugin-datalabels'

const BORDER_RADIUS = 8

// Only the first/last visible segment in a row's stack should round its outer corners;
// segments in the middle of the stack stay square so adjoining colors meet with a single
// clean edge instead of overlapping rounded corners.
function borderRadiusForEdge(edge) {
  switch (edge) {
    case 'only':
      return BORDER_RADIUS
    case 'first':
      return {
        topLeft: BORDER_RADIUS,
        bottomLeft: BORDER_RADIUS,
        topRight: 0,
        bottomRight: 0,
      }
    case 'last':
      return {
        topLeft: 0,
        bottomLeft: 0,
        topRight: BORDER_RADIUS,
        bottomRight: BORDER_RADIUS,
      }
    default:
      return 0
  }
}

export default class extends Controller {
  static values = {
    data: Object,
    options: Object,
  }

  connect() {
    const data = {
      ...this.dataValue,
      datasets: this.dataValue.datasets.map((dataset) => ({
        ...dataset,
        borderRadius: (context) =>
          borderRadiusForEdge(dataset.edgePositions?.[context.dataIndex]),
      })),
    }

    this.chart = new Chart(this.element, {
      type: 'bar',
      data,
      options: {
        ...this.optionsValue,
        scales: {
          ...this.optionsValue.scales,
          x: {
            ...this.optionsValue.scales?.x,
            ticks: {
              ...this.optionsValue.scales?.x?.ticks,
              callback: (value) => `${value}%`,
            },
          },
        },
        plugins: {
          ...this.optionsValue.plugins,
          datalabels: {
            ...this.optionsValue.plugins?.datalabels,
            color: (context) => context.dataset.textColor,
            display: (context) => context.dataset.data[context.dataIndex] > 0,
            formatter: (value, context) => {
              const count = context.dataset.counts[context.dataIndex]

              return `${Math.round(value)}%\n(${count})`
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    })
  }

  disconnect() {
    this.chart?.destroy()
  }
}
